import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { NavigationItem } from '@lyceo/homi-dashboard/shared/util-models';
import { Observable } from 'rxjs';
import {
  ENVIRONMENT,
  EnvironmentModel,
} from '@lyceo/homi-dashboard/shared/util-environment';

@Injectable({
  providedIn: 'root',
})
export class DashboardNavigationService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly environment: EnvironmentModel =
    inject<EnvironmentModel>(ENVIRONMENT);

  public getNavigationItems(): Observable<NavigationItem[]> {
    const url: string = `${this.environment.raymondDashboardApiUrl}/api/menu`;
    const headers: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<NavigationItem[]>(url, { headers });
  }
}
